import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#757575", // Cinza (Gray)
      light: "#9e9e9e",
      dark: "#616161",
      contrastText: "#fff",
    },
    secondary: {
      main: "#9c27b0", // Roxo (Purple)
      light: "#ba68c8",
      dark: "#6a1b9a",
      contrastText: "#fff",
    },
    tertiary: {
      main: "#000000", // Black
      light: "#424242",
      dark: "#000000",
      contrastText: "#fff",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      color: "#000000",
    },
    body1: {
      color: "#424242",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
              borderColor: "#9c27b0",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#9c27b0",
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
